var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_mini",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.014,
    height: 32,
    viewBox: "0 0 34.014 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M493.87,4.634A2.9,2.9,0,0,0,494.3,3.1a2.681,2.681,0,0,0-.455-1.531l-.029-.042A2,2,0,0,0,492.1.711H475.156a1.966,1.966,0,0,0-1.7.875,2.761,2.761,0,0,0-.007,3.115,1.974,1.974,0,0,0,1.71.882h5.993V30.447a2.036,2.036,0,0,0,.958,1.823,2.852,2.852,0,0,0,1.522.438h.034a2.89,2.89,0,0,0,1.5-.417,2.05,2.05,0,0,0,1-1.836V5.573H492.1a1.962,1.962,0,0,0,1.771-.939Z",
    transform: "translate(-462.288 -0.708)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M13.5,27.526H8.4a3.252,3.252,0,0,1-2.228-.583,2.8,2.8,0,0,1-.608-2.065V2.174a1.612,1.612,0,0,0-.981-1.4A3.752,3.752,0,0,0,2.774.31H2.741A3.628,3.628,0,0,0,.958.778,1.6,1.6,0,0,0,.006,2.189V24.846A6.842,6.842,0,0,0,2.193,30.5l.035.028a9.641,9.641,0,0,0,5.58,1.786c.21,0,.42-.007.628-.022h5.035a2.317,2.317,0,0,0,1.895-.766,2.481,2.481,0,0,0-.011-3.273A2.345,2.345,0,0,0,13.5,27.526Z",
    transform: "translate(0.023 -0.309)",
    fill: "#ff8282"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_2147",
    "data-name": "Path 2147",
    transform: "translate(28.014 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M368.6.244l5.329,3.647a.364.364,0,0,1,0,.592L368.6,8.13a.322.322,0,0,1-.344.014.357.357,0,0,1-.176-.311V.537a.357.357,0,0,1,.177-.308.322.322,0,0,1,.342.015Z",
    transform: "translate(-368.08 -0.187)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo_mini.f84831cde106611cfc017ea6a52dc1f7.svg";
export { ForwardRef as ReactComponent };